<nz-card [ngClass]="{'active': isActive}" [nzHoverable]="!isAlert">
  <div class="flex-center-between no-wrap gap-100" style="margin-bottom: 8px;overflow: hidden;">
    <div style="min-width: 0;flex: 0 0 50%; justify-content: start" class="filters-container flex-center">
      <!--      <label *ngIf="checkboxConfig.show" nz-checkbox (nzCheckedChange)="checkboxChange()"-->
      <!--             [nzChecked]="checkboxConfig.isChecked"></label>-->
      <div class="flex-center" style="overflow: hidden">
        @if (icon) {
          <app-st-icon [avatar]="true" [name]="icon"></app-st-icon>
        }
        <span class="text-label-14 text-semibold text-dark text-nowrap" style="text-overflow: ellipsis;">{{ name }}</span>
        <!-- Junto al nombre: como hermano de las dos columnas al 50 % quedaba recortado fuera de la tarjeta (SOU-525) -->
        @if (isAlert) {
          <app-st-icon style="font-size: 20px; flex-shrink: 0"
                       class="cursor-pointer"
                       nz-tooltip="Este servicio tiene un problema de configuración (sin Flujo asignado) y no se puede abrir."
                       [color]="'#CB2A2F'" [filled]="true" [bold]="true" [name]="'error'"></app-st-icon>
        }
      </div>

      @if (!(isMobile$ | async)) {
        <ng-container [ngTemplateOutlet]="ordersTmpl"></ng-container>
      }

    </div>
    <div class="flex gap-100" style="flex: 0 0 50%; justify-content: flex-end; box-sizing: border-box; overflow: hidden; white-space: nowrap; max-width: 50%;">
      @if (!(isMobile$ | async)) {
        <ng-container [ngTemplateOutlet]="providerTmpl"></ng-container>
      }

      @if (!(isMobile$ | async)) {
        <ng-container [ngTemplateOutlet]="actionBtnsTmpl"></ng-container>
      }
    </div>
  </div>
  <div class="flex wrap btm-data">
    <div class="flex" style="max-width: 100%">
      @if (origin) {
        <div class="flex-center gap-075 btm-data-item"  [ngStyle]="{ 'max-width': destination ? '50%' : '100%' }"
             [ngClass]="(isMobile$ | async) ? 'text-label-12' : 'text-label-14'">
          <app-st-icon [name]="origin.locationTypeId | placeIcon"></app-st-icon>
          <label class="text-nowrap">{{ origin.name }}</label>
        </div>
      }
      @if (destination) {
        <app-st-icon [bold]="true" name="arrow_forward"></app-st-icon>
        <div class="flex-center gap-075 btm-data-item" [ngStyle]="{ 'max-width': origin ? '50%' : '100%' }"
             [ngClass]="(isMobile$ | async) ? 'text-label-12' : 'text-label-14'">
          <app-st-icon [name]="destination.locationTypeId | placeIcon"></app-st-icon>
          <label class="text-nowrap">{{ destination.name }}</label>
        </div>
      }
    </div>
  </div>
  @if ((isMobile$ | async)) {
    <div style="margin-top: 7px" class="flex-center-between orders-providers-wrapper">
      <ng-container [ngTemplateOutlet]="ordersTmpl"></ng-container>
      <ng-container [ngTemplateOutlet]="providerTmpl"></ng-container>
    </div>
  }
</nz-card>

<ng-template #actionBtnsTmpl>
  <app-action-btns
    [copy]="actions.copy"
    [file]="actions.file"
    [message]="actions.message"
    [drawer]="actions.drawer"
    (buttonClick)="onAction($event)"
  ></app-action-btns>
</ng-template>

<ng-template #ordersTmpl>
  @if (totalOrders && completedOrders !== undefined) {
    <div class="flex-center gap-050 no-wrap">
      <!--    <nz-progress nzType="circle"-->
      <!--                 [nzWidth]="12"-->
      <!--                 [nzStrokeWidth]="10"-->
      <!--                 [nzShowInfo]="false"-->
      <!--                 [nzPercent]="percent"-->
      <!--                 [nzStatus]="progressStatus">-->
      <!--    ></nz-progress>-->

      <span class="text-label-12 text-semibold text-nowrap">
        <span hidden class="text-dark">{{ completedOrders }} / </span> {{ totalOrders }} Órdenes
      </span>
    </div>
  }
</ng-template>


<ng-template #providerTmpl>
  @if (providers.length > 0) {
    <div class="flex-center gap-200 provider-container" style="flex-wrap: wrap;">
      @if (!(isMobile$ | async)) {
        <span class="text-label-14">Proveedor{{ providers.length > 1 ? 'es' : '' }}:</span>
      }

      <div class="flex-center gap-075" style="flex-wrap: wrap;">
        @for (provider of providers; track provider) {
          <div class="avatar-badge" style="width: fit-content; max-width: 300px; min-width: 0">
            <nz-avatar
              [nzSize]="24"
              [nzSrc]="getSafeImageUrl(provider.avatar)"
              [nzAlt]="provider.name"
            ></nz-avatar>
            <span class="text-label-12 text-dark text-semibold text-nowrap">
                   {{ provider.name }} {{ provider.surName || '' }}
                </span>
          </div>
        }
      </div>
    </div>
  }
</ng-template>
